import React, {useEffect, useState} from "react";
import { Box, Typography, Divider, useMediaQuery, Grid } from "@mui/material";
import CustomTab from "components/Tabs/Tab";
import PropertyDetails from "./propertyDetails";
import axios from "axios";
import { baseURL } from "services/API";
import HouseIcon from "@mui/icons-material/House";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import NearMeIcon from "@mui/icons-material/NearMe";
import PlaceIcon from "@mui/icons-material/Place";
import UnitsTable from "components/Tables/UnitsTable";
import Tickets from "scenes/Tickets";
import UnassignedUnitsTable from "components/Tables/UnassignedUnitsTable";
import PropertyDashboard from "./propertyDashboard";
import { useSelector } from "react-redux";
import { setCurrentTab } from "state";
import { useDispatch } from "react-redux";
import PropertyTenants from "./propertyTenants";
import PropertyManagers from "./propertyManagers";
import PastTenants from "./pastTenants";
import RentArrears from "./rentArrears";
import BulkPaymentsUpload from "components/Forms/BulkPaymentsUpload";
import SecurityDeposits from "./securityDeposits";
import RentalPayments from "./rentalPayments";

const facilityIcons = {
  marginRight: "8px",
  fontSize: "20px",
  color: "#52524e",
};

const coloredIconGreen = {
  marginRight: "8px",
  fontSize: "20px",
  color: "#0af047",
};

const coloredIconRed = {
  marginRight: "8px",
  fontSize: "20px",
  color: "#f20a0a",
};

const detailsText = {
  fontSize: "16px",
  fontWeight: 600,
  padding: "5px",
};

const descriptionText = {
  fontSize: "15px",
  fontWeight: 400,
  fontStyle: "italic",
};




const PropertyDetailsTab = () => {
    const dispatch = useDispatch();
    const id = useSelector((state) => state.property_id);
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
      setValue(newValue);
      dispatch(setCurrentTab({ name: "prropertyTab", tab: newValue }));
    };
    
    const [propertyDetails, setPropertyDetails] = useState({});
    const [rentalName, setRentalName] = useState("");
    const [propertyUse, setPropertyUse] = useState("");
    const [propertyLocation, setPropertyLocation] = useState("");
    const [locationCounty, setLocationCounty] = useState("");
    const [security, setSecurity] = useState("");
    const [hospitalAccess, setHospitalAccess] = useState("");
    const [roadAccess, setRoadAccess] = useState("");
    const [parking, setParking] = useState("");
    const [fibre, setFibre] = useState("");
    const [elevator, setElevator] = useState("");
    const [gym, setGym] = useState("");
    const [pool, setPool] = useState("");

    const isNonMobileScreen = useMediaQuery("(min-width:600px)");

    const fetchDetails = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/landlords/rentals/details?rental_id=${id}`
        );
        setPropertyDetails(response.data.data);
        setRentalName(response.data.data.rental_name);
        setPropertyUse(response.data.data.rental_type);
        setPropertyLocation(response.data.data.location);
        setLocationCounty(response.data.data.location_county);
        setSecurity(response.data.data.has24_security);
        setHospitalAccess(response.data.data.hospital_access);
        setRoadAccess(response.data.data.main_road_access);
        setParking(response.data.data.has_parking);
        setFibre(response.data.data.has_fibre);
        setElevator(response.data.data.has_elevator);
        setGym(response.data.data.has_gym);
        setPool(response.data.data.has_swimming_pool);
      } catch (e) {
        setPropertyDetails(true);
      }
    };

    useEffect(()=>{
        fetchDetails()
    }, [])


    const tabComponents = [
      { Component: <PropertyDashboard handleChange={handleChange}/>, label: "Property DashBoard", index: 0 },
      { Component: <PropertyDetails/>, label: "Property Details", index: 1 },
      { Component: <UnitsTable/>, label: "Units", index: 2 },
      { Component: <PropertyTenants property_id={id}/>, label: "Current Tenants", index: 3 },
      { Component: <UnassignedUnitsTable propertyDetails={propertyDetails}/>, label: "Unoccupied Units", index: 4 },
      { Component: <Tickets/>, label: "Tickets", index: 5 },
      { Component: <PropertyManagers/>, label: "Managers Attached", index: 6 },
      { Component: <PastTenants property_id={id}/>, label: "Past Tenants", index: 7 },
      { Component: <RentArrears/>, label: "Rent Arrears", index: 8 },
      { Component: <BulkPaymentsUpload rentalId={id} />, label: "Bulk Upload", index: 9 },
      { Component: <SecurityDeposits propertyId={id} />, label: "Security Deposits", index: 10 },
      { Component: <RentalPayments rentalId={id} />, label: "Rental Payments", index: 11 },
    ]; 


    return (
      <Box>
        <Box sx={{ alignItems: "baseline", marginBottom: "0", width:"80%", margin:"0 0 0 0.5rem" }}>
            <Grid container sx={{ margin: "0.7rem  0 0 0.5rem" }}>
              <Grid md={2} xs={5.8} sx={{ margin: "0.1rem" }}>
                <Box sx={{ display:"flex", flexDirection: "row" }}>
                  <HouseIcon sx={facilityIcons} />
                  <Typography sx={descriptionText}>Property Name: </Typography>
                </Box>
                <Typography sx={detailsText}>{rentalName}</Typography>
              </Grid>
              <Divider orientation="vertical" variant="middle" flexItem />
              {isNonMobileScreen && 
                <>
                  <Grid md={2} xs={5.8} sx={{ margin: "0.1rem" }}>
                    <Box sx={{ display:"flex", flexDirection: "row" }}>
                      <FormatPaintIcon sx={facilityIcons} />
                      <Typography sx={descriptionText}>Property Use:</Typography>
                    </Box>
                    <Typography sx={detailsText}>{propertyUse}</Typography>
                  </Grid>
                  <Divider orientation="vertical" variant="middle" flexItem />
                  <Grid md={2} xs={5.8} sx={{ margin: "0.1rem" }}>
                    <Box sx={{ display:"flex", flexDirection: "row" }}>
                      <NearMeIcon sx={facilityIcons} />
                      <Typography sx={descriptionText}>Property Location:</Typography>
                    </Box>
                    <Typography sx={detailsText}>{propertyLocation}</Typography>
                  </Grid>
                  <Divider orientation="vertical" variant="middle" flexItem />
                </>
              }
              <Grid md={2} xs={5.8} sx={{ margin: "0.1rem" }}>
                <Box sx={{ display:"flex", flexDirection: "row" }}>
                  <PlaceIcon sx={facilityIcons} />
                  <Typography sx={descriptionText}>Location County:</Typography>
                </Box>
                <Typography sx={detailsText}>{locationCounty}</Typography>
              </Grid>
              {isNonMobileScreen && 
                <>
                  <Divider orientation="vertical" variant="middle" flexItem />
                  <Grid md={2} xs={5.8} sx={{ margin: "0.1rem" }}>
                    <Box sx={{ display:"flex", flexDirection: "row" }}>
                    <Typography sx={descriptionText}>Landlord:</Typography>
                    </Box>
                    {/* <Typography sx={detailsText}>{landlordName}</Typography> */}
                  </Grid>
                  {/* <Divider orientation="vertical" variant="middle" flexItem />
                  <Grid md={2} xs={5.8} sx={{ margin: "0.1rem" }}>
                    <Box sx={{ display:"flex", flexDirection: "row" }}>
                      <Typography sx={descriptionText}>Contact:</Typography>
                    </Box>
                    <Typography sx={detailsText}>{landLordContact}</Typography> 
                  </Grid> */}
                </>
              } 
            </Grid>
        </Box>

        <Divider />
        <CustomTab tabComponents={tabComponents} value={value} handleChange={handleChange}/>
      </Box>
    );

}

export default PropertyDetailsTab;